import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useMeterAssignment} from "../hooks/useMeterAssignment.ts";
import {AssignmentStatus, BillingChannel, MeterAssignment} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {
        createRecord,
    } = useMeterAssignment();

    return (
        <FormDrawer
            record={{
                id: '',
                customerId: '',
                meterId: '',
                channel: BillingChannel.STRIPE,
                channelIdentifiers: {},
                status: AssignmentStatus.ACTIVE,
                effectiveFrom: '',
            } as MeterAssignment}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
